import RoundButton from '@Components/UI/Buttons/RoundButton';
import EdIcon from '@Components/UI/Utilities/EdIcon/EdIcon';
import { useTypedSelector } from '@Features/store';
import { FlexLayout } from '@Styled/utilities';
import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import ReportsTabs from './Components/ReportsTabs';
import { testsReportsExportData } from './Slices/TestsReports.slice';

const ReportsOverview = () => {
	const dispatch = useDispatch();
	const { currentCourse } = useTypedSelector((state) => state.classroom);

	return (
		<>
			<FlexLayout justifyContent="space-between" alignItems="center" mb="2rem">
				<Name> {currentCourse?.name} </Name>
				<ExportButton
					startIcon={<EdIcon fontSize="small">arrow_downward</EdIcon>}
					variant="contained"
					// One row per test: students, passed, failed, average.
					onClick={() => {
						if (!currentCourse) return;
						dispatch(
							testsReportsExportData({
								page: 1,
								perPage: 10,
								filters: [],
								sortBy: {},
								query: '',
								id: currentCourse.id,
							})
						);
					}}
				>
					EXPORT
				</ExportButton>
			</FlexLayout>
			<ReportsTabs />
		</>
	);
};

const Name = styled.p`
	color: #6c63ff;
	font-size: 1.125rem;
	font-weight: bold;
`;
const ExportButton = styled(RoundButton)`
	width: 7.375rem;
	height: 2.75rem;
	box-shadow: 0 5px 6px 0 rgba(0, 0, 0, 0.38);
`;

export default ReportsOverview;
